<template>
  <div class="hashtags" v-if="hashtagString">
    <marquee-text :duration="speed" :repeat="5"
      >&nbsp;{{ hashtagString }}&nbsp;//
    </marquee-text>
  </div>
</template>

<script>
export default {
  props: ['hashtags'],

  computed: {
    speed() {
      return this.hashtags.length * 3;
    },

    hashtagString() {
      return this.hashtags.join(' ');
    }
  }
};
</script>

<style lang="scss">
.hashtags {
  position: absolute;
  bottom: 7vh;
  left: 55vw;
  right: 3vw;
  width: 40vw;
  font-size: 4vh;
  font-weight: 400;
  height: 1.2em;
  overflow: hidden;
  opacity: 0;
  transform: translateX(0);

  transition: all 0.7s ease-in-out;

  &:after,
  &:before {
    content: '';
    z-index: 10;
    position: absolute;
    left: -1px;
    top: 0;
    bottom: 0;
    width: 8vw;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  &:after {
    left: auto;
    right: -1px;
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
}

.display-posts {
  .post.active {
    .hashtags {
      opacity: 1;
    }
  }
  .post:not(.active) {
    .hashtags {
      opacity: 0;
      transform: translateX(100vw);
    }
  }
}

.display-sponsor {
  .hashtags {
    opacity: 0;
    transform: translateX(100vw);
  }
}
</style>
